import { Box, Typography, SxProps } from '@mui/material'

interface LogoProps {
  sx?: SxProps
  color?: string
  textColor?: string
}

const Logo = ({ sx, color = 'primary.main', textColor = 'text.primary' }: LogoProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        ...sx
      }}
    >
      {/* Logo Image */}
      <Box
        component="img"
        src="/images/logo.png"
        alt="Bisworupa Inn Logo"
        sx={{
          width: 45,
          height: 45,
          objectFit: 'contain',
        }}
      />

      {/* Text */}
      <Typography
        variant="h5"
        sx={{
          fontFamily: '"Playfair Display", serif',
          fontWeight: 700,
          color: color,
          letterSpacing: '0.02em',
          textTransform: 'uppercase',
          '&:hover': {
            opacity: 0.9,
          },
        }}
      >
        Bisworupa
        <Box
          component="span"
          sx={{
            color: textColor,
            ml: 1,
            fontWeight: 500,
          }}
        >
          Inn
        </Box>
      </Typography>
    </Box>
  )
}

export default Logo 